/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Eudirective11Inputs */

const id_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directive (UE) 2019/790 tentang hak cipta dan hak terkait di Pasar Tunggal Digital`)
};

const ms_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arahan (EU) 2019/790 mengenai hak cipta dan hak berkaitan dalam Pasaran Tunggal Digital`)
};

const da_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktiv (EU) 2019/790 om ophavsret og beslægtede rettigheder på det digitale indre marked`)
};

const de_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richtlinie (EU) 2019/790 über das Urheberrecht und die verwandten Schutzrechte im digitalen Binnenmarkt`)
};

const en_us2_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directive (EU) 2019/790 on copyright and related rights in the Digital Single Market`)
};

const es_es2_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directiva (UE) 2019/790 sobre derechos de autor y derechos afines en el Mercado Único Digital`)
};

const es_mx2_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directiva (UE) 2019/790 sobre derechos de autor y derechos afines en el Mercado Único Digital`)
};

const fil_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directive (EU) 2019/790 sa copyright at mga kaugnay na karapatan sa Digital Single Market`)
};

const fr_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directive (UE) 2019/790 sur le droit d'auteur et les droits voisins dans le marché unique numérique`)
};

const it_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direttiva (UE) 2019/790 sul diritto d'autore e sui diritti connessi nel mercato unico digitale`)
};

const hu_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(EU) 2019/790 irányelv a szerzői és szomszédos jogokról a digitális egységes piacon`)
};

const nl_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richtlijn (EU) 2019/790 betreffende auteursrechten en naburige rechten in de digitale eengemaakte markt`)
};

const no_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktiv (EU) 2019/790 om opphavsrett og beslektede rettigheter i det digitale indre marked`)
};

const pl_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dyrektywa (UE) 2019/790 w sprawie praw autorskich i praw pokrewnych na jednolitym rynku cyfrowym`)
};

const pt_br2_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diretiva (UE) 2019/790 relativa aos direitos de autor e direitos conexos no Mercado Único Digital`)
};

const pt_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diretiva (UE) 2019/790 sobre direitos de autor e direitos conexos no Mercado Único Digital`)
};

const ro_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directiva (UE) 2019/790 privind drepturile de autor și drepturile conexe pe piața unică digitală`)
};

const fi_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktiivi (EU) 2019/790 tekijänoikeudesta ja siihen liittyvistä oikeuksista digitaalisilla sisämarkkinoilla`)
};

const sv_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktiv (EU) 2019/790 om upphovsrätt och närstående rättigheter på den digitala inre marknaden`)
};

const vi_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ thị (EU) 2019/790 về bản quyền và các quyền liên quan trong Thị trường Kỹ thuật số Duy nhất`)
};

const tr_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dijital Tek Pazarda telif hakkı ve ilgili haklar hakkında Direktif (AB) 2019/790`)
};

const cs_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Směrnice (EU) 2019/790 o autorském právu a právech s ním souvisejících na jednotném digitálním trhu`)
};

const bg_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Директива (ЕС) 2019/790 относно авторското право и сродните му права в цифровия единен пазар`)
};

const ru_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Директива (ЕС) 2019/790 об авторском праве и смежных правах на едином цифровом рынке`)
};

const uk_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Директива (ЄС) 2019/790 про авторське право та суміжні права на цифровому єдиному ринку`)
};

const ar_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوجيه (EU) 2019/790 بشأن حقوق الطبع والنشر والحقوق المجاورة في السوق الرقمية الموحدة`)
};

const hi_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिजिटल सिंगल मार्केट में कॉपीराइट निर्देश (EU) 2019/790`)
};

const th_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำสั่ง (EU) 2019/790 ว่าด้วยลิขสิทธิ์และสิทธิที่เกี่ยวข้องในตลาดดิจิทัลเดียว`)
};

const ja_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタル単一市場における著作権および関連する権利に関する指令 (EU) 2019/790`)
};

const zh_cn2_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第 (EU) 2019/790 号指令：数字单一市场版权和相关权指令`)
};

const zh_hant1_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第 (EU) 2019/790 號指令：數位單一市場版權和相關權指令`)
};

const ko_privacy_eudirective11 = /** @type {(inputs: Privacy_Eudirective11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 단일 시장에서의 저작권 및 관련 권리에 관한 지침 (EU) 2019/790`)
};

/**
* | output |
* | --- |
* | "Directive (EU) 2019/790 on copyright and related rights in the Digital Single Market" |
*
* @param {Privacy_Eudirective11Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_eudirective11 = /** @type {((inputs?: Privacy_Eudirective11Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Eudirective11Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_eudirective11(inputs)
	if (locale === "ms") return ms_privacy_eudirective11(inputs)
	if (locale === "da") return da_privacy_eudirective11(inputs)
	if (locale === "de") return de_privacy_eudirective11(inputs)
	if (locale === "en-US") return en_us2_privacy_eudirective11(inputs)
	if (locale === "es-ES") return es_es2_privacy_eudirective11(inputs)
	if (locale === "es-MX") return es_mx2_privacy_eudirective11(inputs)
	if (locale === "fil") return fil_privacy_eudirective11(inputs)
	if (locale === "fr") return fr_privacy_eudirective11(inputs)
	if (locale === "it") return it_privacy_eudirective11(inputs)
	if (locale === "hu") return hu_privacy_eudirective11(inputs)
	if (locale === "nl") return nl_privacy_eudirective11(inputs)
	if (locale === "no") return no_privacy_eudirective11(inputs)
	if (locale === "pl") return pl_privacy_eudirective11(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_eudirective11(inputs)
	if (locale === "pt") return pt_privacy_eudirective11(inputs)
	if (locale === "ro") return ro_privacy_eudirective11(inputs)
	if (locale === "fi") return fi_privacy_eudirective11(inputs)
	if (locale === "sv") return sv_privacy_eudirective11(inputs)
	if (locale === "vi") return vi_privacy_eudirective11(inputs)
	if (locale === "tr") return tr_privacy_eudirective11(inputs)
	if (locale === "cs") return cs_privacy_eudirective11(inputs)
	if (locale === "bg") return bg_privacy_eudirective11(inputs)
	if (locale === "ru") return ru_privacy_eudirective11(inputs)
	if (locale === "uk") return uk_privacy_eudirective11(inputs)
	if (locale === "ar") return ar_privacy_eudirective11(inputs)
	if (locale === "hi") return hi_privacy_eudirective11(inputs)
	if (locale === "th") return th_privacy_eudirective11(inputs)
	if (locale === "ja") return ja_privacy_eudirective11(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_eudirective11(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_eudirective11(inputs)
	return ko_privacy_eudirective11(inputs)
});
export { privacy_eudirective11 as "privacy.euDirective1" }